import type { MarkupTool } from './markupShapes.ts';

export type MarkupCommand =
    | { type: 'undo' }
    | { type: 'redo' }
    | { type: 'delete' }
    | { type: 'deselect' }
    | { type: 'tool'; tool: MarkupTool };

export interface KeyPress {
    key: string;
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
    altKey: boolean;
}

// Insertion order is the rail order.
export const TOOL_KEYS: Record<MarkupTool, string> = {
    select: 'V',
    pen: 'P',
    arrow: 'A',
    line: 'L',
    rect: 'R',
    ellipse: 'O',
    text: 'T'
};

const TOOL_BY_KEY: ReadonlyMap<string, MarkupTool> = new Map(
    (Object.entries(TOOL_KEYS) as [MarkupTool, string][]).map(([tool, key]) => [
        key.toLowerCase(),
        tool
    ])
);

const DELETE_KEYS: ReadonlySet<string> = new Set(['Delete', 'Backspace']);

function historyCommand(press: KeyPress, isMac: boolean): MarkupCommand | null {
    const key = press.key.toLowerCase();
    if (key === 'z') return press.shiftKey ? { type: 'redo' } : { type: 'undo' };
    if (key === 'y' && !isMac && press.ctrlKey && !press.shiftKey) return { type: 'redo' };
    return null;
}

export function commandForKey(press: KeyPress, isMac: boolean): MarkupCommand | null {
    if (press.altKey) return null;
    if (press.metaKey || press.ctrlKey) return historyCommand(press, isMac);
    if (press.key === 'Escape') return { type: 'deselect' };
    if (press.shiftKey) return null;
    if (DELETE_KEYS.has(press.key)) return { type: 'delete' };
    const tool = TOOL_BY_KEY.get(press.key.toLowerCase());
    return tool ? { type: 'tool', tool } : null;
}

export function isMacPlatform(): boolean {
    return typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.userAgent);
}
